import { getConfig } from "../config";
import { DefaultArtichokeService } from "./artichokeService";
import { PopoutCallService } from "./popoutCallService";
import * as bffService from "./bff";
import { mediaService } from "./mediaService";
import { UsersApi } from "@closerplatform/spinner-openapi";

export async function boot() {
  const bc = new BroadcastChannel("call-popup");
  bc.onmessage = () => window.close();
  bc.postMessage("I am the master");

  await getConfig();
  const artichokeService = new DefaultArtichokeService();
  const callService = new PopoutCallService(artichokeService);
  const usersApi = new UsersApi();
  return {
    artichokeService,
    callService,
    bffService,
    mediaService,
    usersApi,
  }
}

export type Context = Awaited<ReturnType<typeof boot>>;
